import { defineStore } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useI18nStore } from '@/stores/i18n';
import { useNoticePopupStore } from '@/stores/noticePopup';

export const useLocalStorageStore = defineStore('localStorage', {
  actions: {
    saveToLocalStorage() {
      const authStore = useAuthStore();
      const i18nStore = useI18nStore();
      localStorage.setItem(
        'dpost-v1',
        JSON.stringify({
          auth: {
            sessionToken: authStore.sessionToken,
            clientInfo: authStore.clientInfo,
            centerInfo: authStore.centerInfo,
            marketing: authStore.marketingAgreement,
          },
          i18n: {
            locale: i18nStore.locale,
          },
        })
      );
    },
    //로컬스토리지에 데이터 없는 경우 초기화
    savePopupDataLocalStorage() {
      const popupOpenFrom = useNoticePopupStore().isShowToday;
      localStorage.setItem('popupOpenFrom', JSON.stringify(popupOpenFrom));
    },
    removeLocalStorage() {
      localStorage.removeItem('dpost-v1');
    },
  },
});
